import React from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    overflow: 'visible',
  },
  tabs: {
    display: 'flex',
    paddingLeft: '0',
    marginBottom: '0',
    listStyle: 'none',
    borderBottom: `1px solid ${theme.palette.secondary['100']}`,
    flexWrap: 'nowrap',
    overflow: 'auto',
  },
});


const Tabs = (props) => {
  const { classes } = props;
  return (
    <div
      className={classes.root}
    >
      <ul className={classes.tabs}>
        {props.children} {/* NavLinkWrapper */}
      </ul>
    </div>
  );
};

Tabs.propTypes = {
  classes: PropTypes.element.isRequired,
  children: PropTypes.element.isRequired,
};

export default withStyles(styles)(Tabs);
